module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalMainClasses = ['loading'];\nconst additionalSubClasses = ['subForm'];\nlet elementType = '';\nlet childrenRenderedViaFormMapping = false;\nif((config || {}).contextClass){\nadditionalMainClasses.push(config.contextClass);\nadditionalSubClasses.push(config.contextClass);\n}\nif((config || {}).subFormAlias){\n%><div class=\"<%= additionalSubClasses.join(' ') %>\" data-sub-form-alias=\"<%- config.subFormAlias %>\"><%\n} else if ((config || {}).simpleSubForm) {\n%><div class=\"<%= additionalSubClasses.join(' ') %>\"><%\n} else {\n%><form class=\"<%= additionalMainClasses.join(' ') %>\"><%\n}\nif(!config || !config.preventModelFieldsBeingRendered){\nutils.forEach(formMapping.content || [], function(element){\nif ((elementType = (element || {}).type || 'field') === 'section'){\nif((element || {}).name === undefined){\nchildrenRenderedViaFormMapping = true;\n%><%- helpers.renderSection() %><%\n} else {\n%><%- helpers.renderSection(element.name) %><%\n}\n}\nelse {\nif((element || {}).modelFieldIndex === undefined || (model.fields || {})[element.modelFieldIndex] !== undefined){\nif(config.disabled){\nelement.fieldConfig = element.fieldConfig || {};\nelement.fieldConfig.disabled = true;\n}\n%><%- include('elements/' + element.type, { formMapping: element, model: model, config: { preventAllFieldLabels: config.preventAllFieldLabels } }); %><%\n}\n}\n});\n}\nif(!childrenRenderedViaFormMapping){\n%><%- helpers.renderSection(); %><%\n}\nif((config || {}).subFormAlias){\n%></div><%\n} else if ((config || {}).simpleSubForm) {\n%></div><%\n} else {\n%></form><%\n}\n%>"
  , __filename = "node_modules/frontend-controller/baseComponents/bootstrap5/form/form.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalMainClasses = ['loading'];
const additionalSubClasses = ['subForm'];
let elementType = '';
let childrenRenderedViaFormMapping = false;
if((config || {}).contextClass){
additionalMainClasses.push(config.contextClass);
additionalSubClasses.push(config.contextClass);
}
if((config || {}).subFormAlias){

    ; __line = 11
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalSubClasses.join(' ') ))
    ; __append("\" data-sub-form-alias=\"")
    ; __append( config.subFormAlias )
    ; __append("\">")
    ; 
} else if ((config || {}).simpleSubForm) {

    ; __line = 13
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalSubClasses.join(' ') ))
    ; __append("\">")
    ; 
} else {

    ; __line = 15
    ; __append("<form class=\"")
    ; __append(escapeFn( additionalMainClasses.join(' ') ))
    ; __append("\">")
    ; 
}
if(!config || !config.preventModelFieldsBeingRendered){
utils.forEach(formMapping.content || [], function(element){
if ((elementType = (element || {}).type || 'field') === 'section'){
if((element || {}).name === undefined){
childrenRenderedViaFormMapping = true;

    ; __line = 22
    ; __append( helpers.renderSection() )
    ; 
} else {

    ; __line = 24
    ; __append( helpers.renderSection(element.name) )
    ; 
}
}
else {
if((element || {}).modelFieldIndex === undefined || (model.fields || {})[element.modelFieldIndex] !== undefined){
if(config.disabled){
element.fieldConfig = element.fieldConfig || {};
element.fieldConfig.disabled = true;
}

    ; __line = 33
    ; __append( include('elements/' + element.type, { formMapping: element, model: model, config: { preventAllFieldLabels: config.preventAllFieldLabels } }) )
    ; 
}
}
});
}
if(!childrenRenderedViaFormMapping){

    ; __line = 39
    ; __append( helpers.renderSection() )
    ; 
}
if((config || {}).subFormAlias){

    ; __line = 42
    ; __append("</div>")
    ; 
} else if ((config || {}).simpleSubForm) {

    ; __line = 44
    ; __append("</div>")
    ; 
} else {

    ; __line = 46
    ; __append("</form>")
    ; 
}

    ; __line = 48
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/bootstrap5/form/form.ejs

}